module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "choice_brand mt20 mb20"
  }, [_c('div', {
    staticClass: "add_name"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandName))])]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v(_vm._s(_vm.brandDetail.brandEnname))])])]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.brandDetail,
      "label-width": "207px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "品类合作类型："
    }
  }, [_c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.categoryType),
      callback: function($$v) {
        _vm.categoryType = $$v
      },
      expression: "categoryType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌合作品类："
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm.brandDetail.categories && _vm.brandDetail.categories.length > 0 ? [_c('el-table', {
          staticStyle: {
            "width": "92%",
            "margin": "0 auto"
          },
          attrs: {
            "data": _vm.brandDetail.categories,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "主营品类",
            "width": "200",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "是否提供发票",
            "width": "140",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "发票类型",
            "align": "center",
            "width": "180"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 1) ? _c('span', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 2 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票（需去税务局代开）")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry != 1 && scope.row.invoiceType == 3) ? _c('span', [_vm._v("形式发票")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "税率",
            "align": "center",
            "min-width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.rates.length == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((scope.row.rates), function(rateValue) {
                return (scope.row.rates.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(rateValue) + "%\n                                ")]) : _vm._e()
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "200",
            "label": "品类经营特许资质电子版",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.franchiseQualification == 1) ? _c('img', {
                staticClass: "pic_skan",
                attrs: {
                  "src": scope.row.franchiseQualificationFile
                },
                on: {
                  "click": function($event) {
                    _vm.previewPic($event)
                  }
                }
              }) : _vm._e(), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
            }
          }])
        })], 1)] : undefined
      }
    }])
  }), _vm._v(" "), (_vm.brandDetail.categoryNotBook == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "商品是否进口："
    }
  }, [(_vm.brandDetail.goodsType == 1) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("非进口")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("进口")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌经营方式："
    }
  }, [(_vm.brandDetail.businessType == 1) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("自有品牌")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 2) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("代理商")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 3) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("其他")]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 4) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v("课程")]) : _vm._e()]), _vm._v(" "), (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "商标注册证电子版："
    }
  }, [_c('div', [(_vm.brandDetail.trademarkRegistrationCertificateFiles && _vm.brandDetail.trademarkRegistrationCertificateFiles.length > 0) ? _vm._l((_vm.brandDetail.trademarkRegistrationCertificateFiles), function(rcFile, index) {
    return (_vm.brandDetail.trademarkRegistrationCertificateFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "完整授权链证书电子版："
    }
  }, [_c('div', [(_vm.brandDetail.authCertificateFiles && _vm.brandDetail.authCertificateFiles.length > 0) ? _vm._l((_vm.brandDetail.authCertificateFiles), function(rcFile, index) {
    return (_vm.brandDetail.authCertificateFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.businessType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "订货单电子版：",
      "prop": "purchaseOrderFile"
    }
  }, [_c('div', [(_vm.brandDetail.purchaseOrderFiles && _vm.brandDetail.purchaseOrderFiles.length > 0) ? _vm._l((_vm.brandDetail.purchaseOrderFiles), function(rcFile, index) {
    return (_vm.brandDetail.purchaseOrderFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brandDetail.customsDeclarationFormFiles.length > 0),
      expression: "brandDetail.customsDeclarationFormFiles.length > 0"
    }],
    attrs: {
      "label": "报关单扫描件：",
      "prop": "customsDeclarationFormFiles"
    }
  }, [_c('div', [(_vm.brandDetail.customsDeclarationFormFiles && _vm.brandDetail.customsDeclarationFormFiles.length > 0) ? _vm._l((_vm.brandDetail.customsDeclarationFormFiles), function(rcFile, index) {
    return (_vm.brandDetail.customsDeclarationFormFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.registeredCountry == 1 && _vm.brandDetail.goodsType == 1 && (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检单电子版：",
      "prop": "qualityInspectionFiles"
    }
  }, [_c('div', [(_vm.brandDetail.qualityInspectionFiles && _vm.brandDetail.qualityInspectionFiles.length > 0) ? _vm._l((_vm.brandDetail.qualityInspectionFiles), function(rcFile, index) {
    return (_vm.brandDetail.qualityInspectionFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brandDetail.inspectionQuarantineFiles.length > 0),
      expression: "brandDetail.inspectionQuarantineFiles.length > 0"
    }],
    staticClass: "dib",
    attrs: {
      "label": "入境货物检验检疫证明：",
      "prop": "inspectionQuarantineFiles"
    }
  }, [_c('div', [(_vm.brandDetail.inspectionQuarantineFiles && _vm.brandDetail.inspectionQuarantineFiles.length > 0) ? _vm._l((_vm.brandDetail.inspectionQuarantineFiles), function(rcFile, index) {
    return (_vm.brandDetail.inspectionQuarantineFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetail.registeredCountry == 1 && _vm.brandDetail.goodsType == 1 && (_vm.brandDetail.businessType == 1 || _vm.brandDetail.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检日期："
    }
  }, [(_vm.brandDetail.qualityInspectionTime) ? _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm._f("time")(_vm.brandDetail.qualityInspectionTime)))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20 mb20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("品牌详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4410d40f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/supplierInfo/brandDetail.vue
// module id = 518
// module chunks = 0